import {
  Stethoscope, Smile, Pill, HeartPulse, Cog, Briefcase, Cpu, Globe2, Scale,
  BadgeCheck, Languages, Wallet, ScrollText,
} from "lucide-react";

export const DEPARTMENTS = [
  { icon: Stethoscope, name: "Tıp", note: "İngilizce Genel Tıp · YKS'siz kayıt", featured: true },
  { icon: Smile, name: "Diş Hekimliği", note: "Modern klinik eğitim, sınavsız başvuru", featured: true },
  { icon: Pill, name: "Eczacılık", note: "Uluslararası akredite programlar", featured: true },
  { icon: Cog, name: "Mühendislik", note: "Makine, inşaat, elektrik & daha fazlası", featured: true },
  { icon: Scale, name: "Hukuk", note: "Çift diploma & YÖK denkliği seçenekleri", featured: true },
  { icon: Briefcase, name: "İşletme", note: "İngilizce işletme & yönetim" },
  { icon: HeartPulse, name: "Hemşirelik", note: "Uygulamalı sağlık eğitimi" },
  { icon: Cpu, name: "Bilgisayar Bilimi", note: "Yazılım, yapay zeka, veri bilimi" },
  { icon: Globe2, name: "Uluslararası İlişkiler", note: "Diplomasi ve küresel siyaset" },
];

export const WHY = [
  { icon: BadgeCheck, title: "Sınavsız Kayıt", text: "YKS puanına gerek yok. Lise diplomanla doğrudan başvuru." },
  { icon: Languages, title: "İngilizce Eğitim", text: "Programların çoğu tamamen İngilizce dilinde." },
  { icon: Wallet, title: "Uygun Harçlar", text: "Avrupa'ya kıyasla çok daha ekonomik eğitim ücretleri." },
  { icon: ScrollText, title: "Diploma Denkliği", text: "YÖK tarafından tanınan üniversitelerde denklik desteği." },
];

export const UNIVERSITIES = [
  { name: "Abai University + Université de Lorraine", tr: "Abai Üniversitesi + Lorraine Üniversitesi", city: "Almatı", note: "Hukuk çift diploma · YÖK denklikli", img: "/uni/abai.jpg",
    highlight: "Çift Diploma & YÖK Denkliği",
    programs: [
      { name: "Hukuk (Law)", meta: "Lisans · Çift diploma · YÖK denklikli" },
      { name: "Uluslararası İlişkiler ve Diplomasi", meta: "Lisans · Çift diploma" },
      { name: "Yönetim (Management)", meta: "Lisans · Çift diploma" },
      { name: "Finans, Ekonomi, Bankacılık ve Sigortacılık", meta: "Lisans · Çift diploma" },
      { name: "Pazarlama ve Reklamcılık", meta: "Lisans · Çift diploma" },
      { name: "Restoran ve Otel İşletmeciliği", meta: "Lisans · Çift diploma" },
    ] },
  { name: "Al-Farabi Kazakh National University", tr: "Al-Farabi Kazak Ulusal Üniversitesi", city: "Almatı", note: "Kazakistan'ın en büyük ve en köklü ulusal üniversitesi", img: "/uni/alfarabi.jpg",
    programs: [
      { name: "Tıp (MD)", meta: "Lisans · İngilizce grup" },
      { name: "Uluslararası İlişkiler", meta: "Lisans · İngilizce grup" },
      { name: "Uluslararası Hukuk", meta: "Lisans · İngilizce grup" },
      { name: "Ekonomi / Dünya Ekonomisi", meta: "Lisans · İngilizce grup" },
      { name: "Yönetim ve Finans", meta: "Lisans · İngilizce grup" },
      { name: "Bilgisayar Bilimi & Veri Bilimi", meta: "Lisans · İngilizce grup" },
      { name: "Uluslararası Otel Yönetimi", meta: "Lisans · Fransa Vatel çift diploma" },
    ] },
  { name: "L.N. Gumilyov Eurasian National University", tr: "L.N. Gumilyov Avrasya Ulusal Üniversitesi", city: "Astana", note: "Köklü devlet araştırma üniversitesi", img: "/uni/gumilyov.jpg",
    programs: [
      { name: "Ekonomi programları", meta: "Lisans · İngilizce" },
      { name: "Uluslararası İlişkiler", meta: "Lisans · İngilizce" },
      { name: "Bilişim Teknolojileri", meta: "Lisans · İngilizce" },
      { name: "Doğa Bilimleri", meta: "Lisans · İngilizce" },
      { name: "40+ İngilizce program", meta: "Yabancılar mülakatla girer (UNT'siz) · burs imkânı" },
    ] },
  { name: "Satbayev University", tr: "Satbayev Üniversitesi", city: "Almatı", note: "Mühendislik & teknik alanların lideri", img: "/uni/satbayev.jpg",
    programs: [
      { name: "Petrol Mühendisliği", meta: "Lisans · İngilizce · Colorado School of Mines iş birliği" },
      { name: "Siber Güvenlik", meta: "Lisans · İngilizce" },
      { name: "Jeoloji", meta: "Lisans · İngilizce · sınavsız (mülakat)" },
      { name: "Malzeme Bilimi", meta: "Lisans · İngilizce" },
    ] },
  { name: "Astana IT University", tr: "Astana Bilişim Teknolojileri Üniversitesi", city: "Astana", note: "%100 İngilizce, teknoloji odaklı", img: "/uni/astanait.jpg",
    programs: [
      { name: "Yazılım Mühendisliği", meta: "Lisans · %100 İngilizce · 3 yıl" },
      { name: "Bilgisayar Bilimi", meta: "Lisans · %100 İngilizce · 3 yıl" },
      { name: "Büyük Veri Analizi", meta: "Lisans · %100 İngilizce · 3 yıl" },
      { name: "Siber Güvenlik", meta: "Lisans · %100 İngilizce · 3 yıl" },
      { name: "Endüstriyel Nesnelerin İnterneti (IoT)", meta: "Lisans · %100 İngilizce · 3 yıl" },
      { name: "IT Yönetimi / Girişimcilik / AI Business", meta: "Lisans · %100 İngilizce" },
    ] },
  { name: "Yessenov University", tr: "Yessenov Üniversitesi", city: "Aktau", note: "Hazar kıyısında modern kampüs", img: "/uni/yessenov.jpg",
    programs: [
      { name: "Mühendislik programları", meta: "Lisans · İngilizce (kısmi)" },
      { name: "İşletme & Turizm", meta: "Lisans · İngilizce (kısmi)" },
      { name: "Bilişim / Yapay Zekâ", meta: "Lisans · İngilizce (kısmi)" },
      { name: "Hukuk & Uluslararası İlişkiler", meta: "Lisans" },
      { name: "Denizcilik Akademisi", meta: "Lisans" },
    ] },
  { name: "Kozybayev University + University of Arizona", tr: "Kozybayev Üniversitesi + Arizona Üniversitesi", city: "Petropavl", note: "ABD ortaklı çift diploma programı", img: "/uni/kozybayev.jpg",
    programs: [
      { name: "Uygulamalı Biyoteknoloji", meta: "Lisans · İngilizce · Arizona çift diploma" },
      { name: "Bilgi Sistemleri", meta: "Lisans · İngilizce · Arizona çift diploma" },
      { name: "Kapsayıcı Eğitim", meta: "Lisans · İngilizce · çift diploma" },
    ] },
  { name: "Khoja Akhmet Yassawi International Kazakh-Turkish University", tr: "Hoca Ahmet Yesevi Uluslararası Türk-Kazak Üniversitesi", city: "Türkistan", note: "Türkçe eğitim seçeneği", img: "/uni/yesevi.webp",
    programs: [
      { name: "Genel Tıp (MD)", meta: "Lisans · 5 yıl + staj · İngilizce/Türkçe" },
      { name: "9 alanda ~76 lisans programı", meta: "Kazakça / Türkçe / İngilizce / Rusça" },
      { name: "Yabancılar için Hazırlık (Foundation)", meta: "1 yıl · Türk ülkelerine devlet bursları" },
    ] },
  { name: "Asfendiyarov Kazakh National Medical University", tr: "Asfendiyarov Kazak Ulusal Tıp Üniversitesi", city: "Almatı", note: "İngilizce Tıp · köklü tıp fakültesi", img: "/uni/asfendiyarov.webp",
    programs: [
      { name: "Genel Tıp (General Medicine / MD)", meta: "Lisans · 6 yıl (5+1 staj) · İngilizce" },
    ] },
  { name: "Astana Medical University", tr: "Astana Tıp Üniversitesi", city: "Astana", note: "İngilizce Genel Tıp programı", img: "/uni/astanamed.webp",
    programs: [
      { name: "Genel Tıp (General Medicine / MD)", meta: "Lisans · 6 yıl (5+1 staj) · İngilizce" },
    ] },
  { name: "Cardiff University Kazakhstan", tr: "Cardiff Üniversitesi", city: "Astana", note: "Kazakistan kampüsü · İngiliz diploması", img: "/uni/cardiff.jpg",
    programs: [
      { name: "İşletme Yönetimi", meta: "Lisans (BSc) · İngilizce · UK diploması" },
      { name: "Ekonomi ve İşletme", meta: "Lisans (BSc) · İngilizce" },
      { name: "İnşaat Mühendisliği", meta: "Lisans (BEng) · İngilizce" },
      { name: "Bilgisayar Bilimi", meta: "Lisans (BSc) · İngilizce" },
      { name: "Maden Arama Jeolojisi", meta: "Lisans (BSc) · İngilizce" },
      { name: "Modern Dünya için Matematik", meta: "Lisans (BSc) · İngilizce" },
    ] },
  { name: "Coventry University Kazakhstan", tr: "Coventry Üniversitesi", city: "Astana", note: "Kazakistan kampüsü · İngiliz diploması", img: "/uni/coventry.png",
    programs: [
      { name: "Uluslararası İşletme Yönetimi", meta: "Lisans (BSc Hons) · 3 yıl · İngilizce" },
      { name: "İşletme Yönetimi (BBA)", meta: "Lisans · 3 yıl · İngilizce" },
      { name: "Reklam ve Dijital Pazarlama", meta: "Lisans (BA Hons) · İngilizce" },
      { name: "Bilgisayar Bilimi", meta: "Lisans (BSc Hons) · İngilizce" },
      { name: "Yapay Zekâ ile Bilgisayar Bilimi", meta: "Lisans (BSc Hons) · İngilizce" },
    ] },
  { name: "De Montfort University Kazakhstan", tr: "De Montfort Üniversitesi", city: "Almatı", note: "Kazakistan kampüsü · İngiliz diploması", img: "/uni/demontfort.jpg",
    programs: [
      { name: "Muhasebe ve Finans", meta: "Lisans · 3 yıl · İngilizce · UK diploması" },
      { name: "İşletme ve Pazarlama", meta: "Lisans · 3 yıl · İngilizce" },
      { name: "Hukuk (LLB)", meta: "Lisans · 3 yıl · İngilizce" },
      { name: "Ekonomi ve Uluslararası İlişkiler", meta: "Lisans · 3 yıl · İngilizce" },
      { name: "Finans ve Yatırımlar", meta: "Lisans · 3 yıl · İngilizce" },
      { name: "Grafik Tasarım ve İllüstrasyon", meta: "Lisans · 3 yıl · İngilizce" },
    ] },
  { name: "Heriot-Watt University Kazakhstan", tr: "Heriot-Watt Üniversitesi", city: "Almatı", note: "Kazakistan kampüsü · İskoç diploması", img: "/uni/heriotwatt.webp",
    programs: [
      { name: "Elektrik ve Elektronik Sistemleri", meta: "Lisans (BEng) · 4 yıl · çift diploma" },
      { name: "Petrol ve Geçiş Mühendisliği", meta: "Lisans (BEng) · 4 yıl · çift diploma" },
      { name: "Yazılım Müh. ile Hesaplamalı Bilimler", meta: "Lisans (BSc) · 4 yıl · çift diploma" },
    ] },
  { name: "Zhubanov University", tr: "Zhubanov Üniversitesi", city: "Aktöbe", note: "Köklü bölgesel devlet üniversitesi", img: "/uni/zhubanov.jpg",
    programs: [
      { name: "Heriot-Watt çift diploma mühendislik/bilişim", meta: "Lisans · İngilizce" },
      { name: "~79 lisans programı", meta: "Kazakça / Rusça · hazırlık dil kursları" },
    ] },
  { name: "Nazarbayev University", tr: "Nazarbayev Üniversitesi", city: "Astana", note: "Tümüyle İngilizce, öncü araştırma üniversitesi", img: "/uni/nazarbayev.jpg",
    programs: [
      { name: "Tıp (Medicine)", meta: "Lisans/Doktora · %100 İngilizce" },
      { name: "Bilgisayar Bilimi", meta: "Lisans (BSc) · 4 yıl · %100 İngilizce" },
      { name: "Kimya ve Malzeme Mühendisliği", meta: "Lisans (BEng) · %100 İngilizce" },
      { name: "Petrol Mühendisliği", meta: "Lisans (BSc) · %100 İngilizce" },
      { name: "Fen ve Beşeri Bilimler", meta: "Lisans · %100 İngilizce · 1 yıl NUFYP hazırlık" },
    ] },
  { name: "Narxoz University", tr: "Narxoz Üniversitesi", city: "Almatı", note: "İşletme, ekonomi & hukuk odaklı", img: "/uni/narxoz.jpg",
    programs: [
      { name: "Finans / Finansal Risk Yönetimi", meta: "Lisans · İngilizce (üç dilli)" },
      { name: "Muhasebe, Yönetim, Pazarlama, Ekonomi", meta: "Lisans · İngilizce" },
      { name: "Hukuk & Uluslararası İlişkiler", meta: "Lisans · İngilizce" },
      { name: "Dijital Teknolojiler / Turizm-Otelcilik", meta: "Lisans · İngilizce" },
    ] },
];

export const ENROLLMENT = {
  timeline: "Başvurular her yıl Temmuz–Ağustos aylarında yapılır. Yeni eğitim-öğretim yılı Eylül'ün ilk haftası başlar.",
  documents: [
    { title: "Pasaport", note: "Geçerli pasaport" },
    { title: "Lise Diploması ve Transkript", note: "Aslına Türkiye'den Apostil yaptırılıp getirilir" },
    { title: "Noter Tasdikli Kazakça Çeviri", note: "Diploma ve transkriptin noter onaylı Kazakça çevirisi" },
    { title: "Sağlık Raporu", note: "Kazakistan'daki hastanelerden alınır" },
    { title: "6 Adet Fotoğraf", note: "3x4 boyutunda vesikalık" },
    { title: "Diploma Denkliği", note: "Kazakistan'a varışta üniversite yönlendirir · yaklaşık 15 iş günü sürer" },
  ],
  notes: [
    "Yabancı öğrenciler için sınav, mülakat şeklinde yapılır.",
    "Kazakça bilmeyen adaylar üniversite bünyesinde 1 yıl hazırlık eğitimi görür.",
    "Kazakistan'da eğitim dili İngilizce olan birçok üniversite bulunur.",
    "Türkçe eğitim için Hoca Ahmet Yesevi Uluslararası Türk-Kazak Üniversitesi faaliyet gösterir.",
  ],
};

export const STEPS = [
  { n: "01", title: "Ücretsiz Danışmanlık", text: "Uzman ekibimizle tanış, hedeflerini paylaş." },
  { n: "02", title: "Üniversite & Bölüm Seçimi", text: "Sana en uygun üniversite ve bölümü birlikte belirleyelim." },
  { n: "03", title: "Belge Hazırlığı", text: "Apostil, noter tasdikli Kazakça çeviri ve denklik işlemleri." },
  { n: "04", title: "Kayıt ve Kabul", text: "Resmi kaydını tamamla, kabul mektubunu al." },
];

export const SERVICES = [
  { title: "Üniversite & Bölüm Seçimi", text: "Hedeflerine göre doğru programı belirliyoruz." },
  { title: "Başvuru ve Kayıt İşlemleri", text: "Tüm başvuru sürecini biz yönetiyoruz." },
  { title: "Belge & Denklik Desteği", text: "Apostil, çeviri ve denklik işlemleri." },
  { title: "Vize İşlemleri", text: "Öğrenci vizesi başvurusunda tam destek." },
  { title: "Konaklama / Yurt Desteği", text: "Güvenli yurt ve konaklama seçenekleri." },
  { title: "Havalimanı Karşılama", text: "İniş anından itibaren yanındayız." },
];

export const TESTIMONIALS = [
  { name: "Elif Yıldız", uni: "Astana Medical University", text: "YKS puanım düşüktü, umudumu kaybetmiştim. Study in KZ sayesinde Astana'da tıp okuyorum. Süreç boyunca hep yanımdaydılar.", stars: 5 },
  { name: "Mert Kaya", uni: "Astana IT University", text: "Bilgisayar bilimi için mükemmel bir tercih oldu. Vize ve konaklama dahil her şeyi hallettiler. Kesinlikle tavsiye ederim.", stars: 5 },
  { name: "Zeynep Demir", uni: "Asfendiyarov National Medical University", text: "Diş hekimliği hayalimdi. Sınavsız kayıt gerçekten mümkünmüş! Belge işlemlerinde çok yardımcı oldular.", stars: 5 },
];

export const FAQ = [
  { q: "YKS puanım yok/düşük, kayıt olabilir miyim?", a: "Evet! Türk öğrenciler YKS puanına gerek olmadan, sınavsız olarak Tıp, Diş Hekimliği, Eczacılık ve diğer bölümlere kayıt olabilir. Lise diploman başvuru için yeterlidir." },
  { q: "Eğitim dili İngilizce mi?", a: "Anlaşmalı üniversitelerimizin büyük çoğunluğunda programlar tamamen İngilizce yürütülmektedir. Ayrıca Türkçe eğitim seçeneği sunan üniversitelerimiz de mevcuttur." },
  { q: "Kazakça bilmem gerekiyor mu? (hazırlık yılı)", a: "İngilizce programlar için Kazakça bilmeniz gerekmez. İhtiyaç halinde bir yıllık hazırlık programı ile dil desteği sağlanır." },
  { q: "Harç ücretleri ne kadar?", a: "Harçlar üniversite ve bölüme göre değişir ancak Avrupa ve diğer yurt dışı seçeneklerine kıyasla oldukça ekonomiktir. Ücretsiz danışmanlıkta size net bilgi veriyoruz." },
  { q: "Diploma Türkiye'de geçerli/denk mi?", a: "Anlaşmalı üniversitelerimiz YÖK tarafından tanınmaktadır. Denklik sürecinde size tam destek sağlıyoruz." },
  { q: "Vize ve konaklama nasıl oluyor?", a: "Öğrenci vizesi başvurusundan yurt/konaklama ayarlamasına, havalimanı karşılamadan yerleşime kadar tüm süreçte yanınızdayız." },
  { q: "Başvuru ne zaman yapılır?", a: "Başvurular genellikle yaz aylarında yoğunlaşır ancak kontenjanlar sınırlıdır. En doğru zamanlama için hemen ücretsiz danışmanlık alın." },
];

export const DEPARTMENT_OPTIONS = [
  "Tıp", "Diş Hekimliği", "Eczacılık", "Mühendislik",
  "İşletme", "Bilgisayar Bilimi", "Diğer",
];

export const CONTACT = {
  email: "info@studyinkz.org",
  phone: "+90 533 859 15 17",
  whatsapp: "905338591517",
};
